// extracted by mini-css-extract-plugin
module.exports = {"box":"TableMobileRowContent_box__2vozO"};